import type { ColumnaFuncion } from '@/services/asistenteService';
import type { IdFuncionPoder } from '@/content/ejemplosPoderes';

// El catálogo del asistente (catalogoFuncionesE1) es la única fuente de funciones (D-22): aquí solo
// se fija el orden en que el lienzo las lee (Poderes_Chat, de arriba abajo y de izquierda a derecha),
// sin nombres ni descripciones. Un test exige que los grupos cubran exactamente el catálogo y que
// cada función esté en la columna que el catálogo le da.

export type { IdFuncionPoder };

export interface GrupoPoderes {
    readonly columna: ColumnaFuncion;
    readonly nombre: string;
    readonly funciones: readonly IdFuncionPoder[];
}

export const GRUPOS_PODERES: readonly GrupoPoderes[] = [
    { columna: 'analizar', nombre: 'Analizar', funciones: ['preguntar_historial', 'plan_terapeutico', 'psicometria'] },
    {
        columna: 'redactar',
        nombre: 'Redactar',
        funciones: ['documentos_por_secciones', 'plantillas_clinicas', 'manuscritos'],
    },
    { columna: 'organizar', nombre: 'Organizar', funciones: ['cronologia', 'carpetas', 'fecha_real'] },
    { columna: 'para_ti', nombre: 'Para ti', funciones: ['notas_fijas', 'ayuda'] },
];

/** El orden del DOM de escritorio: el teclado recorre las pestañas grupo a grupo. */
export const FUNCIONES_EN_ORDEN: readonly IdFuncionPoder[] = GRUPOS_PODERES.flatMap((g) => g.funciones);

export const FUNCION_INICIAL: IdFuncionPoder = 'preguntar_historial';

export function grupoDeFuncion(id: IdFuncionPoder): GrupoPoderes {
    const grupo = GRUPOS_PODERES.find((g) => g.funciones.includes(id));
    if (!grupo) throw new Error(`La función «${id}» no está en ningún grupo de Poderes del chat`);
    return grupo;
}

const PASOS: Readonly<Record<string, number>> = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };

/** Índice al que lleva una tecla en una lista de pestañas con vuelta; otra tecla no mueve nada. */
export function siguienteIndice(actual: number, tecla: string, total: number): number {
    if (tecla === 'Home') return 0;
    if (tecla === 'End') return total - 1;
    if (!Object.hasOwn(PASOS, tecla)) return actual;
    return (actual + PASOS[tecla] + total) % total;
}
